import { ApiModule, type PaginatedResponseData } from '@common/index';
import type { PersonDetailsItem, PersonDetails } from '../models';

export class PersonDetailsApi extends ApiModule {
  protected endpoint = '/person-details';

  public async pagePersonDetailss(params: any) {
    return this.api.post<PaginatedResponseData<PersonDetailsItem>, any>(
      `${this.endpoint}/page?page=${params.page}&size=${params.itemsPerPage}&sort=${params.sort ?? ''}&sort=${params.sort ?? ''}`,
      {
        ...params
      }
    );
  }

  public loadPersonDetailsDetails(id: number) {
    return this.api.get<PersonDetails>(`${this.endpoint}?id=${id}`);
  }
  public loadPersonDetailsByPersonId(id: number) {
    return this.api.get<PersonDetails>(`${this.endpoint}/person?id=${id}`);
  }

  public savePersonDetails(params: any) {
    return this.api.post<any, PersonDetails>(`${this.endpoint}`, {
      ...params
    });
  }

  public deletePersonDetails(id: number) {
    return this.api.delete(`${this.endpoint}?id=${id}`);
  }
}
